import React from 'react';
import { MoreHorizontal } from 'lucide-react';

const MetricCard = ({
  title,
  headerRight,
  statsContent,
  chartContent,
  bottomContent,
  className = '',
    titleIcon=null
}) => {
  return (
    <div className={`bg-white rounded-md shadow-sm w-full market-view-card ${className}`}>
      {/* Header */}
      <div className="flex justify-between items-center px-4 pt-4 pb-2">
          <div className={'flex flex-row items-center'}>
              {titleIcon}
              <div className="text-xl metric-title pl-3">{title}</div>
          </div>
          {headerRight || (
              <button className="text-gray-400">
              <MoreHorizontal className="w-5 h-5" />
          </button>
        )}
      </div>

      {/* Stats Grid */}
      <div className="px-8 pb-2">
        {statsContent}
      </div>

      {/* Chart */}
      <div className="h-40 px-4 pb-2">
        {chartContent}
      </div>

      {/* Bottom Content */}
      <div className="px-8 pb-4">
        {bottomContent}
      </div>
    </div>
  );
};

export default MetricCard;